export const COMPOSER_MIN_HEIGHT_PX = 44;
export const COMPOSER_MAX_HEIGHT_PX = 150;

export function resizeComposer(textarea, {
  minHeightPx = COMPOSER_MIN_HEIGHT_PX,
  maxHeightPx = COMPOSER_MAX_HEIGHT_PX,
} = {}) {
  if (!textarea) {
    return {
      heightPx: minHeightPx,
      overflowY: 'hidden',
    };
  }

  textarea.style.height = 'auto';
  const measuredHeight = Math.max(textarea.scrollHeight, minHeightPx);
  const heightPx = Math.min(measuredHeight, maxHeightPx);
  const overflowY = measuredHeight > maxHeightPx ? 'auto' : 'hidden';

  textarea.style.height = `${heightPx}px`;
  textarea.style.overflowY = overflowY;

  return { heightPx, overflowY };
}
